import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* providers */
import { PagarMeTransacaoModelService } from './pagarmetransacao.model.service';
import { VitrineModelService } from './vitrine.model.service';
import { LiquidacaoParcelaModelService } from './liquidacaoparcela.model.service';
import { ParametrosModelService } from './parametros.model.service';
import { ConsumidorSiteClientModelService } from './consumidorsiteclient.model.service';
import { LojaModelService } from './loja.model.service';
import { PagamentoPIXModelService } from './pagamentopix.model.service';
import { ZoopModelService } from './zoop.model.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    PagarMeTransacaoModelService,
    VitrineModelService,
    LiquidacaoParcelaModelService,
    ParametrosModelService,
    ConsumidorSiteClientModelService,
    LojaModelService,
    PagamentoPIXModelService,
    ZoopModelService
  ]
})
export class ModelServiceModule { }
